import React, { Component } from "react";
import { connect } from "react-redux";
import Card from "Utils/Cards/Card";
import { ListaSolicitudes } from "../components/ListaSolicitudes";
import "../styles/Solicitudes.css";
import { getNombreAcopio } from "../../../../../../../utility/utils";
import { LAB_PRODUCCION_ESTADOS_DRC } from "../../../../../../../utility/constants";

class PendientesAnalisis extends Component {
    render() {
        const { user } = this.props;
        const nombreAcopio = getNombreAcopio(user);

        return (
            <div className="mb-4 col-12" style={{ maxWidth: "95vw" }}>
                <Card
                    icon="laboratorio_activo"
                    titulo="LABORATORIO DE PRODUCCIÓN"
                    subtitulo="Pendientes de análisis"
                    noBorder
                >
                    <ListaSolicitudes
                        storageKey="lab_produccion_pendientes_state"
                        estadoSolicitudes="PENDIENTES"
                        nombreAcopio={nombreAcopio}
                    />
                </Card>
            </div>
        );
    }
}

const mstp = (state) => {
    const configuraciones = state.configuracion.configuraciones;
    const user = state.login.me;

    return {
        configuraciones,
        user,
    };
};

export default connect(mstp, {})(PendientesAnalisis);
